module.exports = __webpack_public_path__ + "img/2daa222e17f2cfc639c655945863890f.png";